import React, { useEffect, useState } from 'react';
import EditModal1 from './Modal/EditModal1';
import { connect, useDispatch, useSelector } from 'react-redux';
import { adminActions } from '../../_actions';
import AdminTbale from './AdminTbale';
import ViewModal from './Modal/ViewModal';
import Input from '../../components/ui/Input/Input';
import DeleteModal from '../../components/Modals/DeleteModal';
import AdminRoles from "./AdminRoles.json";
import CustomerView from './Modal/CustomerView';

function AdminManagement1() {
    const dispatch = useDispatch();
    const [selectedIds, setSelectedIds] = useState([]);
    const [isMenu, setIsMenu] = useState(false)
    const [isCustomerView, setIsCustomerView] = useState(false);
    const [clickedUserId, setClickedUserId] = useState(null)
    const [isEditModal, setIsEditModal] = useState(false)
    const [error, setError] = useState({});
    const size = 10;
    const [isViewModal, setIsViewModal] = useState(false)
    const [isViewData, setIsViewData] = useState(null)
    const [searchText, setSearchText] = useState("")
    const [isDeleteModal, setIsDeletModal] = useState(false)
    const [deleteData, setDeleteData] = useState(null);
    const [selectedAccess, setSelectedAccess] = useState([]);
    const [allCustomerSelected, setAllCustomerSelected] = useState(false);
    const [filterData, setFilterData] = useState({
        size: size,
        sortBy: "id",
        sortOrder: "DESC",
        keyWord: ""
    });
    const [editData, setEditData] = useState({
        name: '',
        user_name: '',
        email: '',
        phone: '',
        passwd: '',
        confirmPasswd: '',
        admin_type: 'admin',
        parent_admin_id: "",
        access: 'admin',
    });
    const adminList = useSelector(state => state.admin.adminList);
    const adminTypeList = useSelector(state => state.admin.adminTypeList);
    const adminData = useSelector((state) => state.users.adminData);
    const adminType = adminData?.admin_type || "admin";
    useEffect(() => {
        setFilterData((p) => ({ ...p, keyWord: searchText }));
        dispatch(adminActions.adminList({ ...filterData, keyWord: searchText }));
        dispatch(adminActions.adminTypeAdmin());
    }, [searchText, dispatch]);

    function handlePageClick(e) {
        setFilterData((p) => ({ ...p, page: e.selected + 1, size }));
        dispatch(adminActions.adminList({ ...filterData, page: e.selected + 1, size }));
    }
    const theadData = [
        "Id",
        "User Name",
        'email',
        "Phone",
        'Admin Type',
        "Actions"
    ];
    const admin = useSelector(state => state.admin);
    const handleEdit = async (data) => {
        setIsEditModal(!isEditModal)
        await dispatch(adminActions.getAssignedCustomerIds({ id: data?.id }));
        setEditData({
            id: data.id,
            user_name: data?.user_name || "",
            access: data?.access.split(",") || [],
            admin_type: data?.admin_type || "",
            name: data?.name || "",
            email: data?.email || "",
            phone: data?.phone || 0,
            parent_admin_id: data?.parent_admin_id || "",
        });
        const preselectedKeys = data.access.split(",") || [];
        const preselectedOptions = AdminRoles.filter(role =>
            preselectedKeys.includes(role.value)
        );
        const preselectedOptions1 = preselectedOptions?.filter(e => e != "admin_manag");
        setSelectedAccess(preselectedOptions1);
        setSelectedIds(admin?.ids || []);
    }
    const handleOnChange = (e) => {
        const { value, name } = e.target;
        // const validKeys = ['name', 'user_name', 'phone', 'admin_type', 'access', 'email', 'passwd', 'confirmPasswd'];
        // if (validKeys.includes(name)) {
        //     if (name === "phone") {
        //         if (String(value).length !== 10) {
        //             setError({ ...error, [name]: `${name} must have ${10} charactor.` })
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     } else if (name === "admin_type") {
        //         if (!value) {
        //             setError({ ...error, [name]: `Please select admin type.` });
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     } else if (name === "access") {
        //         if (!value) {
        //             setError({ ...error, [name]: `Please select access.` });
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     } else if (name === "email") {
        //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        //         if (!emailRegex.test(value)) {
        //             setError({ ...error, [name]: `Invalid email format.` });
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     } else if (name === "passwd" || name === "confirmPasswd") {
        //         if (String(value).length < 8) {
        //             setError({ ...error, [name]: `${name} must have at least ${8} characters.` });
        //         } else if (name === "confirmPasswd" && value !== document.getElementById('passwd').value) {
        //             setError({ ...error, [name]: `Passwords do not match.` });
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     } else {
        //         if (String(value).length < 3) {
        //             let message = null;
        //             if (name === 'name') {
        //                 message = `Name must have at leat ${3} charactor.`;
        //             } else if (name === 'user_name') {
        //                 message = `User Name must have at leat ${3} charactor.`;
        //             }
        //             setError({ ...error, [name]: message });
        //         } else {
        //             setError({ ...error, [name]: null });
        //         }
        //     }
        // }
        setEditData({
            ...editData, [name]: value
        })
    }
    const validate = (validKeys, obj_p) => {
        let returnV = false;
        // const tempError = { ...error };
        const tempError = obj_p;
        validKeys.forEach(name => {
            if (name === "phone") {
                if (String(editData[name] || "").length !== 10) {
                    tempError[name] = `Phone number must have ${10} charactor.`;
                    returnV = true;
                } else {
                    tempError[name] = null;
                }
            } else if (name === "email") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(editData[name] || "")) {
                    returnV = true;
                    tempError[name] = `Invalid email format.`;
                } else {
                    tempError[name] = null;
                }
            } else if (name === "passwd" || name === "confirmPasswd") {
                if (String(editData[name] || "").length < 8) {
                    returnV = true;
                    tempError[name] = `${name === 'passwd' ? "Password" : "Confirm Password"} must have at least ${8} characters.`;
                } else if (name === "confirmPasswd" || name === "passwd") {
                    if (editData['passwd'] !== editData['confirmPasswd']) {
                        returnV = true;
                        tempError[name] = `Passwords do not match.`;
                    } else {
                        tempError[name] = null;
                    }
                } else {
                    tempError[name] = null;
                }
            } else if (name === "admin_type") {
                if (!editData[name] || "") {
                    tempError[name] = `Please select admin type.`;
                    returnV = true;
                } else {
                    tempError[name] = null;
                }
            } else if (name === "access") {
                if (selectedAccess.length === 0) {
                    tempError[name] = `Please select at least one access.`;
                    returnV = true;
                } else {
                    tempError[name] = null;
                }
            } else if (name === "name") {
                if (!editData[name] || "") {
                    tempError[name] = `Name required.`;
                    returnV = true;
                } else {
                    tempError[name] = null;
                }
            } else {
                if (String(editData[name] || "").length < 3) {
                    let message = null;
                    if (name === 'user_name') {
                        message = `User Name must have at leat ${3} charactor.`;
                    }
                    tempError[name] = `${message}`;
                    returnV = true;
                } else {
                    tempError[name] = null;
                }
            }
        });
        setError(tempError);
        return returnV;
    }
    const handleEditSubmit = (e) => {
        e.preventDefault();
        setError(() => ({}));
        let obj_p = {};
        // return;
        if (adminType === "super") {
            if (editData?.admin_type === "sub_admin") {
                if (!editData?.parent_admin_id) {
                    obj_p = {
                        parent_admin_id: "Please select admin for this sub admin",
                    }
                }
            }
        }
        if (editData?.id) {
            let validKeys = ['name', 'user_name', 'phone', 'access', 'email'];
            if (editData?.passwd || editData?.confirmPasswd) {
                validKeys.push("passwd");
                validKeys.push("confirmPasswd")
            }
            const isValid = validate(validKeys, obj_p);
            if (isValid) return;
            editData.access = selectedAccess.map(acess => acess.value).join(",");
            if (allCustomerSelected) {
                editData.allSelected = "yes";
            }
            dispatch(adminActions.updateAdmin({ ...editData, assigned_admin_id: selectedIds || [], admin_type: "sub_admin" }, handleClose, filterData))
        } else {
            const validKeys = ['name', 'user_name', 'phone', 'access', 'email', 'passwd', 'confirmPasswd'];
            const isValid = validate(validKeys, obj_p);
            if (isValid) return;
            editData.access = selectedAccess.map(acess => acess.value).join(",");
            if (allCustomerSelected) {
                editData.allSelected = "yes";
            }
            dispatch(adminActions.saveAdmin({ ...editData, assigned_admin_id: selectedIds || [], admin_type: "sub_admin" }, handleClose, filterData));
        }
    }
    const handleUserDelete = (data) => {
        setIsDeletModal(!isDeleteModal)
        setDeleteData(data?.id)
    }
    const handleDelete = () => {
        dispatch(adminActions.softDelete({ id: deleteData }));
        setIsDeletModal(!isDeleteModal)
    }
    const toggleDeleteModal = () => { setIsDeletModal(!isDeleteModal) }

    const handleClose = () => {
        setIsEditModal(!isEditModal)
        setEditData({})
        setError({});
        setSelectedAccess([]);
        setSelectedIds([]);
    }
    const handleView = (data) => {
        setIsViewModal(!isViewModal);
        setIsViewData(data)
    }
    const toggleViewModal = () => { setIsViewModal(!isViewModal); setIsViewData(null) }

    const showMenu = (userId) => {
        if (clickedUserId === userId) {
            setIsMenu(!isMenu);
        } else {
            setClickedUserId(userId);
            setIsMenu(true);
        }
    };

    const handleCreate = () => {
        setIsEditModal(!isEditModal)
    }
    const handleUserBlock = (data) => {
        dispatch(adminActions.softDelete(data));
        dispatch(adminActions.adminList(filterData));
    }
    const handleCustomerView = () => {
        setIsCustomerView(!isCustomerView);
    }
    const handleSelectUser = (id) => {
        if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
        } else {
            setSelectedIds([...selectedIds, id]);
        }
    };
    const handleAddCustomer = () => {
        handleCustomerView();
    }
    const handleAddAllCustomer = () => {
        // handleCustomerView();
        setAllCustomerSelected(!allCustomerSelected)
    }


    return (
        <>
            <div className="w-full p-3 bgcolor h-screen overflow-y-auto overflow-hidden">
                <div className="p-4 bg-white rounded-md mx-auto w-full space-y-4">
                    <div className='flex flex-wrap justify-between items-center w-full space-y-2'>
                        <Input className="w-full" placeholder={`Search...`} value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                        <button className='px-4 py-2 bgbtn rounded w-64' onClick={handleCreate}>Create New</button>
                    </div>

                    <AdminTbale setFilterData={setFilterData} filterData={filterData} theadData={theadData} tbodyData={adminList} handleEdit={handleEdit} showMenu={showMenu} isMenu={isMenu} clickedUserId={clickedUserId} handleUserBlock={handleUserBlock} handleView={handleView} handleUserDelete={handleUserDelete} handlePageClick={handlePageClick} size={size} />
                </div>


                {isEditModal &&
                    <EditModal1 selectedIds={selectedIds} setSelectedIds={setSelectedIds} handleCustomerView={handleCustomerView} isOpen={isEditModal} onClose={handleClose} editData={editData} handleOnChange={handleOnChange} handleEditSubmit={handleEditSubmit} selectedAccess={selectedAccess} setSelectedAccess={setSelectedAccess} error={error}
                        adminTypeList={adminTypeList} />
                }
                {isCustomerView &&
                    <CustomerView handleAddAllCustomer={handleAddAllCustomer} allCustomerSelected={allCustomerSelected} setSelectedIds={setSelectedIds} handleAddCustomer={handleAddCustomer} handleView={handleCustomerView} handleSelectUser={handleSelectUser} selectedIds={selectedIds}></CustomerView>
                }
                {
                    isViewData && (<ViewModal data={isViewData} onClose={toggleViewModal} />)
                }
                {
                    isDeleteModal && (<DeleteModal isOpen={isDeleteModal} onSubmit={handleDelete} closeModal={toggleDeleteModal} />)
                }
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { user } = state
    return {
        user
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AdminManagement1)